module.exports={
	"Form": "CertificationTypeCreateManifest",
	"Scope": "CertificationType-Create",
	"Descriptors":
	{
		"CertificationTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "CertificationType-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "CertificationType-Create-Identity",
				"Group": "CertificationType-Create-Identity"
			}
		},
		"CertificationTypeDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "CertificationType-Create-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "CertificationType-Create-Details",
				"Group": "CertificationType-Create-Details"
			}
		},
		"CertificationTypeDetails.Verb":
		{
			"Name": "Verb",
			"Hash": "CertificationType-Create-Verb",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "CertificationType-Create-Details",
				"Group": "CertificationType-Create-Details"
			}
		},
		"CertificationTypeDetails.Description":
		{
			"Name": "Description",
			"Hash": "CertificationType-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "CertificationType-Create-Details",
				"Group": "CertificationType-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "CertificationType-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "CertificationType-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "CertificationType-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "CertificationType-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
